import { useQuery } from '@tanstack/react-query';
import { GET, GET_MOBILES } from '../../../../services';

/**
 * เครื่องที่ลงทะเบียนไว้ของใบรับประกัน (ยี่ห้อ/รุ่น + warrantyMobileId)
 * ตัดตัวเลือก "อื่นๆ" (warrantyMobileId = -1) ที่ API ต่อท้ายมาสำหรับหน้าแจ้งเคลมออก
 */
export const useGetWarrantyMobiles = (warrantyId) => {
  const { data, isFetching, isSuccess, isError } = useQuery({
    queryKey: ['warrantyMobilesRaw', warrantyId],
    queryFn: async () => {
      const response = await GET(GET_MOBILES(warrantyId));
      const items = response?.result?.items || [];
      return items.filter((item) => item?.warrantyMobileId > 0);
    },
    enabled: !!warrantyId,
  });

  return {
    warrantyMobiles: data,
    loading: isFetching,
    ready: isSuccess && !isFetching,
    hasError: isError,
  };
};
